import React from "react";
import { Link } from "react-router-dom";
import "./Navigation.css"; // We'll create/update this CSS file

function Navigation() {
  return (
    <nav className="nav-container">
      <div className="nav-inner">
        <h1 className="site-title">National Renewables Network Review</h1>
        <div className="nav-links">
          <Link to="/" className="nav-button">Home</Link>
          <Link to="/submit" className="nav-button">Write a Review</Link>
        </div>
      </div>
<div className="banner-container">
  <img
    src="/images/nrn-banner.png"
    alt="NRN Review Banner"
    className="banner-image"
  />
</div>
    </nav>
  );
}

export default Navigation;


